// DO NOT ADD ANY NEW IMPORTS HERE.
// NOTE: These constants, structs, and functions must match those in rawevents.proto
var RawEventKind;
(function (RawEventKind) {
  RawEventKind.MUT_INSERT = 2;
  RawEventKind.MUT_REMOVE = 3;
  RawEventKind.MUT_ATTR = 4;
  RawEventKind.MUT_TEXT = 6;
  RawEventKind.MOUSEMOVE = 8;
  RawEventKind.MOUSEMOVE_CURVE = 9;
  RawEventKind.SCROLL_LAYOUT = 10;
  RawEventKind.SCROLL_LAYOUT_CURVE = 11;
  RawEventKind.MOUSEDOWN = 12;
  RawEventKind.MOUSEUP = 13;
  RawEventKind.CLICK = 16;
  RawEventKind.FOCUS = 17;
  RawEventKind.VALUECHANGE = 18;
  RawEventKind.RESIZE_LAYOUT = 19;
  RawEventKind.DOMLOADED = 20;
  RawEventKind.LOAD = 21;
  RawEventKind.PLACEHOLDER_SIZE = 22;
  RawEventKind.UNLOAD = 23;
  RawEventKind.BLUR = 24;
  RawEventKind.SET_FRAME_BASE = 25;
  RawEventKind.TOUCHSTART = 32;
  RawEventKind.TOUCHEND = 33;
  RawEventKind.TOUCHCANCEL = 34;
  RawEventKind.TOUCHMOVE = 35;
  RawEventKind.TOUCHMOVE_CURVE = 36;
  RawEventKind.NAVIGATE = 37;
  RawEventKind.PLAY = 38;
  RawEventKind.PAUSE = 39;
  RawEventKind.RESIZE_VISUAL = 40;
  RawEventKind.RESIZE_VISUAL_CURVE = 41;
  RawEventKind.RESIZE_DOCUMENT_CONTENT = 42;
  RawEventKind.RESIZE_SCROLLABLE_ELEMENT_CONTENT = 43;
  RawEventKind.LOG = 48;
  RawEventKind.ERROR = 49;
  RawEventKind.DBL_CLICK = 50;
  RawEventKind.FORM_SUBMIT = 51;
  RawEventKind.WINDOW_FOCUS = 52;
  RawEventKind.WINDOW_BLUR = 53;
  RawEventKind.HEARTBEAT = 54;
  RawEventKind.WATCHED_ELEM = 56;
  RawEventKind.PERF_ENTRY = 57;
  RawEventKind.REC_FEAT_SUPPORTED = 58;
  RawEventKind.SELECT = 59;
  RawEventKind.CSSRULE_INSERT = 60;
  RawEventKind.CSSRULE_DELETE = 61;
  RawEventKind.FAIL_THROTTLED = 62;
  RawEventKind.AJAX_REQUEST = 63;
  RawEventKind.SCROLL_VISUAL_OFFSET = 64;
  RawEventKind.SCROLL_VISUAL_OFFSET_CURVE = 65;
  RawEventKind.MEDIA_QUERY_CHANGE = 66;
  RawEventKind.RESOURCE_TIMING_BUFFER_FULL = 67;
  RawEventKind.MUT_SHADOW = 68;
  RawEventKind.DISABLE_STYLESHEET = 69;
  RawEventKind.FULLSCREEN = 70;
  RawEventKind.FULLSCREEN_ERROR = 71;
  RawEventKind.ADOPTED_STYLESHEETS = 72;
  RawEventKind.CUSTOM_ELEMENT_DEFINED = 73;
  RawEventKind.MODAL_OPEN = 74;
  RawEventKind.MODAL_CLOSE = 75;
  RawEventKind.SLOW_INTERACTION = 76;
  RawEventKind.LONG_FRAME = 77;
  RawEventKind.TIMING = 78;
  RawEventKind.STORAGE_WRITE_FAILURE = 79;
  RawEventKind.DOCUMENT_PROPERTIES = 80;
  RawEventKind.ENTRY_NAVIGATE = 81;
  RawEventKind.STATS = 82;
  RawEventKind.VIEWPORT_INTERSECTION = 83;
  RawEventKind.COPY = 84;
  RawEventKind.PASTE = 85;
  RawEventKind.URL_SALT = 86;
  RawEventKind.URL_ID = 87;
  RawEventKind.FRAME_STATUS = 88;
  RawEventKind.SCRIPT_COMPILED_VERSION = 89;
  RawEventKind.RESET_CSS_SHEET = 90;
  RawEventKind.ANIMATION_CREATED = 91;
  RawEventKind.ANIMATION_METHOD_CALLED = 92;
  RawEventKind.ANIMATION_PROPERTY_SET = 93;
  RawEventKind.DOCUMENT_TIMELINE_CREATED = 94;
  RawEventKind.KEYFRAME_EFFECT_CREATED = 95;
  RawEventKind.KEYFRAME_EFFECT_METHOD_CALLED = 96;
  RawEventKind.KEYFRAME_EFFECT_PROPERTY_SET = 97;
  RawEventKind.CAPTURE_SOURCE = 98;
  RawEventKind.PAGE_DATA = 99;
  RawEventKind.VISIBILITY_STATE = 100;
  RawEventKind.DIALOG = 101;
  RawEventKind.CSSRULE_UPDATE = 102;
  RawEventKind.CANVAS = 103;
  RawEventKind.CANVAS_DETACHED_DIMENSION = 104;
  RawEventKind.INIT_API = 105;
  RawEventKind.DEFERRED_RESOLVED = 106;
  RawEventKind.DEFERRED_MUT_INSERT = 107;
  RawEventKind.DEFERRED_MUT_SHADOW = 108;
  RawEventKind.ELEMENT_PROP = 109;
  RawEventKind.BFCACHE_STATE = 110;
  RawEventKind.SESSION_INFO = 111;
  RawEventKind.KEEP_ELEMENT = 2000;
  RawEventKind.KEEP_URL = 2001;
  RawEventKind.KEEP_BOUNCE = 2002;
  RawEventKind.SYS_SETVAR = 8193;
  RawEventKind.SYS_RESOURCEHASH = 8195;
  RawEventKind.SYS_SETCONSENT = 8196;
  RawEventKind.SYS_CUSTOM = 8197;
  RawEventKind.SYS_REPORTCONSENT = 8198;
  RawEventKind.SYS_LETHE_MOBILE_BUNDLE_SEQ = 8199;
})(RawEventKind || (RawEventKind = {}));
// The types of animations that can be recorded
var RecAnimationType;
(function (RecAnimationType) {
  RecAnimationType.Animation = 0;
  RecAnimationType.CSSAnimation = 1;
  RecAnimationType.CSSTransition = 2;
})(RecAnimationType || (RecAnimationType = {}));
var TimingScope;
(function (TimingScope) {
  TimingScope.Internal = 0;
  TimingScope.Public = 1;
})(TimingScope || (TimingScope = {}));
var TimingCategory;
(function (TimingCategory) {
  TimingCategory.Unknown = 0;
  TimingCategory.Serialization = 1;
})(TimingCategory || (TimingCategory = {}));
var TimingLabel;
(function (TimingLabel) {
  TimingLabel.Unknown = 0;
  TimingLabel.DomSnapshot = 1;
  TimingLabel.NodeEncoding = 2;
  TimingLabel.LzEncoding = 3;
  TimingLabel.ApplyRules = 4;
  TimingLabel.ProcessMut = 5;
})(TimingLabel || (TimingLabel = {}));
var FrameStatus;
(function (FrameStatus) {
  FrameStatus.Unknown = 0;
  FrameStatus.Successful = 1;
  FrameStatus.BlocklistedFrame = 2;
  FrameStatus.PartiallyLoaded = 3;
  FrameStatus.MissingWindowOrDocument = 4;
  FrameStatus.MissingDocumentHead = 5;
  FrameStatus.MissingBodyOrChildren = 6;
  FrameStatus.AlreadyDefined = 7;
  FrameStatus.NoNonScriptElement = 8;
  FrameStatus.Exception = 9;
})(FrameStatus || (FrameStatus = {}));
var BfcacheState;
(function (BfcacheState) {
  BfcacheState[BfcacheState["Unset"] = 0] = "Unset";
  BfcacheState[BfcacheState["Entering"] = 1] = "Entering";
  BfcacheState[BfcacheState["Restored"] = 2] = "Restored";
})(BfcacheState || (BfcacheState = {}));
var CssRuleIdKind;
(function (CssRuleIdKind) {
  CssRuleIdKind[CssRuleIdKind["Index"] = 1] = "Index";
  CssRuleIdKind[CssRuleIdKind["Cached"] = 2] = "Cached";
})(CssRuleIdKind || (CssRuleIdKind = {}));
var ConsentState;
(function (ConsentState) {
  ConsentState.GrantConsent = true;
  ConsentState.RevokeConsent = false;
})(ConsentState || (ConsentState = {}));
var ConsentScope;
(function (ConsentScope) {
  ConsentScope.Page = 0;
  ConsentScope.Document = 1;
})(ConsentScope || (ConsentScope = {}));
// Constants used in RawEventKind.UNLOAD.
// todo(clint) comments display legacy reason values, remove after Nov 2019
var UnloadReason;
(function (UnloadReason) {
  UnloadReason.Unknown = 0;
  UnloadReason.Api = 1;
  UnloadReason.FsShutdownFrame = 2;
  UnloadReason.Hibernation = 3;
  UnloadReason.Reidentify = 4;
  UnloadReason.SettingsBlocked = 5;
  UnloadReason.Size = 6;
  UnloadReason.Unload = 7;
  UnloadReason.Hidden = 8;
})(UnloadReason || (UnloadReason = {}));
/**
 * Reasons why the Ajax req/res body was empty
 */
var AjaxLegibility;
(function (AjaxLegibility) {
  AjaxLegibility.Unknown = 0;
  AjaxLegibility.NotEmpty = 1;
  AjaxLegibility.EmptyBody = 2;
})(AjaxLegibility || (AjaxLegibility = {}));
/**
 * Values from the browser Performance API, for use with
 * RawEventKind.PERF_ENTRY.
 */
var PerfEntryType;
(function (PerfEntryType) {
  PerfEntryType.Timing = 0;
  PerfEntryType.Navigation = 1;
  PerfEntryType.Resource = 2;
  PerfEntryType.Paint = 3;
  PerfEntryType.Mark = 4;
  PerfEntryType.Measure = 5;
  PerfEntryType.Memory = 6;
  PerfEntryType.TimeOrigin = 7;
  PerfEntryType.LayoutShift = 8;
  PerfEntryType.FirstInput = 9;
  PerfEntryType.LargestContentfulPaint = 10;
  PerfEntryType.LongTask = 11;
  PerfEntryType.EventTiming = 12;
  PerfEntryType.EventTimingCount = 13;
})(PerfEntryType || (PerfEntryType = {}));
/**
 * Field orders for the various performance entry types.
 * NOTE: Do _not_ change the ordering. They are the sole definition of what's in
 * the args field.
 * TODO(sethf): Change this to a mapped type where the keys are PerfEntryType.
 * We currently can't do this because PerfEntryType is a union of numeric
 * literal types, and we're compiling with keyofStringsOnly because of some
 * difficulties with index signature types elsewhere in the code base.
 * Fortunately, those problems should go away with TypeScript 4.2, thanks to
 * this PR:
 *   https://github.com/microsoft/TypeScript/pull/26797
 */
var PerfEntryFields;
(function (PerfEntryFields) {
  PerfEntryFields.Timing = ['navigationStart', 'unloadEventStart', 'unloadEventEnd', 'redirectStart', 'redirectEnd', 'fetchStart', 'domainLookupStart', 'domainLookupEnd', 'connectStart', 'connectEnd', 'secureConnectionStart', 'requestStart', 'responseStart', 'responseEnd', 'domLoading', 'domInteractive', 'domContentLoadedEventStart', 'domContentLoadedEventEnd', 'domComplete', 'loadEventStart', 'loadEventEnd'];
  PerfEntryFields.Navigation = ['name', 'startTime', 'duration', 'initiatorType', 'redirectStart', 'redirectEnd', 'fetchStart', 'domainLookupStart', 'domainLookupEnd', 'connectStart', 'connectEnd', 'secureConnectionStart', 'requestStart', 'responseStart', 'responseEnd', 'unloadEventStart', 'unloadEventEnd', 'domInteractive', 'domContentLoadedEventStart', 'domContentLoadedEventEnd', 'domComplete', 'loadEventStart', 'loadEventEnd', 'type', 'redirectCount',
  // Possibly non-standard, but supported by chrome+firefox (not edge).
  'decodedBodySize', 'encodedBodySize', 'transferSize', 'activationStart'];
  PerfEntryFields.Resource = ['name', 'startTime', 'duration', 'initiatorType', 'redirectStart', 'redirectEnd', 'fetchStart', 'domainLookupStart', 'domainLookupEnd', 'connectStart', 'connectEnd', 'secureConnectionStart', 'requestStart', 'responseStart', 'responseEnd',
  // Possibly non-standard, but supported by chrome+firefox (not edge).
  'decodedBodySize', 'encodedBodySize', 'transferSize'];
  PerfEntryFields.Measure = ['name', 'startTime', 'duration'];
  PerfEntryFields.Memory = ['jsHeapSizeLimit', 'totalJSHeapSize', 'usedJSHeapSize'];
  PerfEntryFields.TimeOrigin = ['timeOrigin'];
  PerfEntryFields.LayoutShift = ['startTime', 'value', 'hadRecentInput'];
  PerfEntryFields.FirstInput = ['name', 'startTime', 'duration', 'processingStart'];
  PerfEntryFields.EventTiming = ['name', 'startTime', 'duration', 'processingStart', 'processingEnd', 'interactionId'];
  PerfEntryFields.LargestContentfulPaint = ['name', 'startTime', 'duration', 'renderTime', 'loadTime', 'size'];
  PerfEntryFields.EventTimingCount = ['interactionCount'];
})(PerfEntryFields || (PerfEntryFields = {}));
// Feature types for RawEventKind.REC_FEAT_SUPPORTED:
var RecFeature;
(function (RecFeature) {
  RecFeature.Performance = 0;
  RecFeature.PerformanceEntries = 1;
  RecFeature.PerformanceMemory = 2;
  RecFeature.Console = 3;
  RecFeature.Ajax = 4;
  RecFeature.PerformanceObserver = 5;
  RecFeature.PerformanceTimeOrigin = 7;
  RecFeature.WebAnimation = 8;
  RecFeature.LayoutShift = 9;
  RecFeature.FirstInput = 10;
  RecFeature.LargestContentfulPaint = 11;
  RecFeature.LongTask = 12;
  RecFeature.HTMLDialogElement = 13;
  RecFeature.CaptureOnStartupEnabled = 14;
  RecFeature.CanvasWatcherEnabled = 15;
  RecFeature.CanvasScreenShotMode = 16;
  RecFeature.ResizeObserver = 17;
})(RecFeature || (RecFeature = {}));
var SheetOwner;
(function (SheetOwner) {
  SheetOwner.Node = 1;
  SheetOwner.Sheet = 2;
})(SheetOwner || (SheetOwner = {}));
// Throttled task types for RawEventKind.FAIL_THROTTLED.
var ThrottledTask;
(function (ThrottledTask) {
  ThrottledTask.StyleSheetHooks = 0;
  ThrottledTask.SetPropertyHooks = 1;
})(ThrottledTask || (ThrottledTask = {}));
// Scopes for RawEventKind.SYS_SETVAR.
var VarScope;
(function (VarScope) {
  VarScope.Document = 'document';
  VarScope.Event = 'evt';
  VarScope.Page = 'page';
  VarScope.User = 'user';
})(VarScope || (VarScope = {}));
var HighlightType;
(function (HighlightType) {
  HighlightType["FsId"] = 'fsidentity';
  HighlightType["NewUid"] = 'newuid';
})(HighlightType || (HighlightType = {}));
// Constants used in AjaxWatch.[ReqRsp]BodyType.
var AjaxBodyPolicy;
(function (AjaxBodyPolicy) {
  AjaxBodyPolicy.Elide = 0;
  AjaxBodyPolicy.Record = 1;
  AjaxBodyPolicy.Allowlist = 2;
})(AjaxBodyPolicy || (AjaxBodyPolicy = {}));
// enums used for attribute blocking; these should match the values found in recording.proto
var AttributeBlockTarget;
(function (AttributeBlockTarget) {
  AttributeBlockTarget.Any = 0;
  AttributeBlockTarget.Exclude = 1;
  AttributeBlockTarget.Mask = 2;
})(AttributeBlockTarget || (AttributeBlockTarget = {}));
/**
 * List of possible actions to be performed on a blocked attribute
 * NOTE: this must be in descending privacy order; that is, the more strict rules must come first
 * When there are overlapping entries, the lowest value action is used
 */
var AttributeBlockAction;
(function (AttributeBlockAction) {
  AttributeBlockAction.Erase = 0;
  AttributeBlockAction.MaskText = 1;
  AttributeBlockAction.ScrubUrl = 2;
  AttributeBlockAction.ScrubCss = 3;
})(AttributeBlockAction || (AttributeBlockAction = {}));
var AttributeBlockType;
(function (AttributeBlockType) {
  AttributeBlockType.Static = 0;
  AttributeBlockType.Prefix = 1;
})(AttributeBlockType || (AttributeBlockType = {}));
var BehaviorSignalType;
(function (BehaviorSignalType) {
  BehaviorSignalType.SignalInvalid = 0;
  BehaviorSignalType.SignalDeadClick = 1;
  BehaviorSignalType.SignalRageClick = 2;
})(BehaviorSignalType || (BehaviorSignalType = {}));
// keep in sync with recording.go
var BlockReasonType;
(function (BlockReasonType) {
  BlockReasonType.ReasonNoSuchOrg = 1;
  BlockReasonType.ReasonOrgDisabled = 2;
  BlockReasonType.ReasonOrgOverQuota = 3;
  BlockReasonType.ReasonBlockedDomain = 4;
  BlockReasonType.ReasonBlockedIp = 5;
  BlockReasonType.ReasonBlockedUserAgent = 6;
  BlockReasonType.ReasonBlockedGeo = 7;
  BlockReasonType.ReasonBlockedTrafficRamping = 8;
  BlockReasonType.ReasonInvalidURL = 9;
  BlockReasonType.ReasonUserOptOut = 10;
  BlockReasonType.ReasonInvalidRecScript = 11;
  BlockReasonType.ReasonDeletingUser = 12;
  BlockReasonType.ReasonNativeHookFailure = 13;
})(BlockReasonType || (BlockReasonType = {}));
// Constants used in ElementBlock.Type.
// Keep in sync with fs/model.BlockType.
var BlockType;
(function (BlockType) {
  BlockType.Unset = 0;
  BlockType.Exclude = 1;
  BlockType.Mask = 2;
  BlockType.Unmask = 3;
  BlockType.Watch = 4;
  BlockType.Keep = 5;
  BlockType.Defer = 6;
})(BlockType || (BlockType = {}));
// Constants used in ElementKeepType.
// Keep in sync with fs/model.KeepType.
var KeepType;
(function (KeepType) {
  KeepType.Unset = 0;
  KeepType.Click = 1;
})(KeepType || (KeepType = {}));
var SockRequestCommand;
(function (SockRequestCommand) {
  SockRequestCommand[SockRequestCommand["Page"] = 1] = "Page";
  SockRequestCommand[SockRequestCommand["Bundle"] = 2] = "Bundle";
})(SockRequestCommand || (SockRequestCommand = {}));
var SockResponseCommand;
(function (SockResponseCommand) {
  SockResponseCommand[SockResponseCommand["Error"] = 3] = "Error";
  SockResponseCommand[SockResponseCommand["Page"] = 4] = "Page";
  SockResponseCommand[SockResponseCommand["Bundle"] = 5] = "Bundle";
  SockResponseCommand[SockResponseCommand["Settings"] = 6] = "Settings";
})(SockResponseCommand || (SockResponseCommand = {}));
///////////////////////////////////////////////////////////////////////////////
// Recording constants, possibly shared with UI code.
///////////////////////////////////////////////////////////////////////////////
var Constants;
(function (Constants) {
  var MaxPerfMarksPerPage = Constants.MaxPerfMarksPerPage = 16 * 1024;
  var MaxLogsPerPage = Constants.MaxLogsPerPage = 1024;
  var MaxUrlLength = Constants.MaxUrlLength = 2048;
  var MutationProcessingInterval = Constants.MutationProcessingInterval = 250;
  Constants.CurveSamplingInterval = 142;
  Constants.DefaultBundleUploadInterval = 5000;
  Constants.HeartbeatInterval = 4.27 * 60 * 1000;
  Constants.PageInactivityTimeout = 30 * 60 * 1000;
  Constants.BackoffMax = 5 * 60 * 1000;
  Constants.ScrollSampleInterval = MutationProcessingInterval / 5;
  Constants.InactivityThreshold = 4000;
  var MaxAjaxPayloadLength = Constants.MaxAjaxPayloadLength = 16 * 1024;
  Constants.DefaultOrgSettings = {
    MaxPerfMarksPerPage: MaxPerfMarksPerPage,
    MaxConsoleLogPerPage: MaxLogsPerPage,
    MaxAjaxPayloadLength: MaxAjaxPayloadLength,
    MaxUrlLength: MaxUrlLength,
    RecordPerformanceResourceImg: true,
    RecordPerformanceResourceTiming: true,
    HttpRequestHeadersAllowlist: [],
    HttpResponseHeadersAllowlist: [],
    UrlPrivacyConfig: [{
      Exclude: {
        Hash: [{
          Expression: '#.*'
        }],
        QueryParam: [{
          Expression: '(=)(.*)'
        }]
      }
    }],
    // by default, if no org settings is detected, wipe every attribute
    AttributeBlocklist: [{
      Target: AttributeBlockTarget.Any,
      Tag: '*',
      Name: '',
      Type: AttributeBlockType.Prefix,
      Action: AttributeBlockAction.Erase
    }]
  };
  Constants.DefaultStatsSettings = {
    MaxPayloadLength: 8192,
    // NOTE: Max length is intended to prevent fraudulent data, not to limit the feature. -SN (1/4/22)
    MaxEventTypeLength: 1024
  };
  Constants.BlockedFieldValue = '__fs__redacted';
  Constants.DefaultRecDisabledMessage = 'Capture disabled. Turn on debug mode for more information.';
  Constants.ShutdownMessage = 'Shutdown called.';
})(Constants || (Constants = {}));
var CaptureState;
(function (CaptureState) {
  CaptureState[CaptureState["Shutdown"] = 1] = "Shutdown";
  CaptureState[CaptureState["Starting"] = 2] = "Starting";
  CaptureState[CaptureState["Started"] = 3] = "Started";
  CaptureState[CaptureState["Fatal"] = 4] = "Fatal";
})(CaptureState || (CaptureState = {}));
var CanvasOpType;
(function (CanvasOpType) {
  CanvasOpType.Set = 0;
  CanvasOpType.Function = 1;
})(CanvasOpType || (CanvasOpType = {}));
var CanvasWatcherMode;
(function (CanvasWatcherMode) {
  CanvasWatcherMode[CanvasWatcherMode["Disabled"] = 0] = "Disabled";
  CanvasWatcherMode[CanvasWatcherMode[
  /**
  * captures the operations done directly to the canvas and replay
  * advantages:
  * 1. for simpler operations this is smaller footprint
  * 2. allows potentially content masking
  * 3. all operations should be captured so nothing gets lost
  * disadvantages:
  * 1. operations done prior to initialization could be missed
  * 2. complex webgl operations do not work well, especially if
  *    script manipulates buffers, because each of those buffers must
  *    be encoded by us
  */
  "CaptureCanvasOps"] = 1] = "CaptureCanvasOps";
  CanvasWatcherMode[CanvasWatcherMode[
  /**
  * uses the screenshots of canvases and upload as screenshots
  * the advantages/disadvantages of this is almost entirely inverse of the above
  * advantages:
  * 1. for complex operations this is smaller footprint (esp webgl)
  * 2. captures current state of canvas, regardless of FS initialization
  * disadvantages:
  * 1. does not allow content masking (unless we redraw onto an in memory FS canvas)
  * 2. depends on the rate of refresh, could miss things drawn on canvas that goes away
  * 3. for simpler operation this is larger footprint
  */
  "ScreenshotCanvas"] = 2] = "ScreenshotCanvas";
})(CanvasWatcherMode || (CanvasWatcherMode = {}));
var Messages;
(function (Messages) {
  Messages["EndPreviewMode"] = "EndPreviewMode";
  Messages["EvtBundle"] = "EvtBundle";
  Messages["GreetFrame"] = "GreetFrame";
  Messages["InitFrameMobile"] = "InitFrameMobile";
  Messages["RequestFrameId"] = "RequestFrameId";
  Messages["RestartFrame"] = "RestartFrame";
  Messages["SetConsent"] = "SetConsent";
  Messages[
  /**
  * Important note! Any changes here must be reflected in the `InitFrameMobile`, as there are
  * long-lived mobile clients in the field that expect the stable interface to work.
  */
  "SetFrameId"] = "SetFrameId";
  Messages["ShutdownFrame"] = "ShutdownFrame";
  Messages[/** Unknown used as fallback, consider this a noop and internal only */"Unknown"] = "Unknown";
})(Messages || (Messages = {}));
Messages.RequestFrameId;
Messages.EvtBundle;

// @ts-nocheck
var SnippetSrcV2 = "!function(m,n,e,t,l,o,g,y){var s,f,a=function(h){\nreturn!(h in m)||(m.console&&m.console.log&&m.console.log('FullStory namespace conflict. Please set window[\"_fs_namespace\"].'),!1)}(e)\n;function j(b){var h,d=[];function k(){h&&(d.forEach((function(b){var d;try{d=b[h[0]]&&b[h[0]](h[1])}catch(h){return void(b[3]&&b[3](h))}\nd&&d.then?d.then(b[2],b[3]):b[2]&&b[2](d)})),d.length=0)}function r(b){return function(d){h||(h=[b,d],k())}}return b(r(0),r(1)),{\nthen:function(b,h){return j((function(r,i){d.push([b,h,r,i]),k()}))}}}a&&(g=m[e]=function(){var b=function(b,d,k,r){function i(i,c){\nh(b,d,k,i,c,r)}r=r||2;var c,u=/Async$/;return u.test(b)?(b=b.replace(u,\"\"),\"function\"==typeof Promise?new Promise(i):j(i)):h(b,d,k,c,c,r)}\n;function h(h,d,k,r,i,c){return b._api?b._api(h,d,k,r,i,c):(b.q&&b.q.push([h,d,k,r,i,c]),null)}return b.q=[],b}(),y=function(b){function h(h){\n\"function\"==typeof h[4]&&h[4](new Error(b))}var d=g.q;if(d){for(var k=0;k<d.length;k++)h(d[k]);d.length=0,d.push=h}},function(){\n(o=n.createElement(t)).async=!0,o.crossOrigin=\"anonymous\",o.src=\"https://\"+l,o.onerror=function(){y(\"Error loading \"+l)}\n;var b=n.getElementsByTagName(t)[0];b.parentNode.insertBefore(o,b)}(),function(){function b(){}function h(b,h,d){g(b,h,d,1)}function d(b,d,k){\nh(\"setProperties\",{type:b,properties:d},k)}function k(b,h){d(\"user\",b,h)}function r(b,h,d){k({uid:b},d),h&&k(h,d)}g.identify=r,g.setUserVars=k,\ng.identifyAccount=b,g.clearUserCookie=b,g.setVars=d,g.event=function(b,d,k){h(\"trackEvent\",{name:b,properties:d},k)},g.anonymize=function(){r(!1)\n},g.shutdown=function(){h(\"shutdown\")},g.restart=function(){h(\"restart\")},g.log=function(b,d){h(\"log\",{level:b,msg:d})},g.consent=function(b){\nh(\"setIdentity\",{consent:!arguments.length||b})}}(),s=\"fetch\",f=\"XMLHttpRequest\",g._w={},g._w[f]=m[f],g._w[s]=m[s],m[s]&&(m[s]=function(){\nreturn g._w[s].apply(this,arguments)}),g._v=\"2.0.0\")}(window,document,window._fs_namespace,\"script\",window._fs_script);";
var executeSnippet = function executeSnippet() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$wnd = _ref.wnd,
    wnd = _ref$wnd === void 0 ? window : _ref$wnd;
  !function (m, n, e, t, l, o, g, y) {
    var s,
      f,
      a = function (h) {
        return !(h in m) || (m.console && m.console.log && m.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].'), !1);
      }(e);
    function j(b) {
      var h,
        d = [];
      function k() {
        h && (d.forEach(function (b) {
          var d;
          try {
            d = b[h[0]] && b[h[0]](h[1]);
          } catch (h) {
            return void (b[3] && b[3](h));
          }
          d && d.then ? d.then(b[2], b[3]) : b[2] && b[2](d);
        }), d.length = 0);
      }
      function r(b) {
        return function (d) {
          h || (h = [b, d], k());
        };
      }
      return b(r(0), r(1)), {
        then: function then(b, h) {
          return j(function (r, c) {
            d.push([b, h, r, c]), k();
          });
        }
      };
    }
    a && (g = m[e] = function () {
      var b = function b(_b2, d, k, r) {
        function c(c, i) {
          h(_b2, d, k, c, i, r);
        }
        r = r || 2;
        var i,
          u = /Async$/;
        return u.test(_b2) ? (_b2 = _b2.replace(u, ""), "function" == typeof Promise ? new Promise(c) : j(c)) : h(_b2, d, k, i, i, r);
      };
      function h(h, d, k, r, c, i) {
        return b._api ? b._api(h, d, k, r, c, i) : (b.q && b.q.push([h, d, k, r, c, i]), null);
      }
      return b.q = [], b;
    }(), y = function y(b) {
      function h(h) {
        "function" == typeof h[4] && h[4](new Error(b));
      }
      var d = g.q;
      if (d) {
        for (var k = 0; k < d.length; k++) h(d[k]);
        d.length = 0, d.push = h;
      }
    }, function () {
      (o = n.createElement(t)).async = !0, o.crossOrigin = "anonymous", o.src = "https://" + l, o.onerror = function () {
        y("Error loading " + l);
      };
      var b = n.getElementsByTagName(t)[0];
      b.parentNode.insertBefore(o, b);
    }(), function () {
      function b() {}
      function h(b, h, d) {
        g(b, h, d, 1);
      }
      function d(b, d, k) {
        h("setProperties", {
          type: b,
          properties: d
        }, k);
      }
      function k(b, h) {
        d("user", b, h);
      }
      function r(b, h, d) {
        k({
          uid: b
        }, d), h && k(h, d);
      }
      g.identify = r, g.setUserVars = k, g.identifyAccount = b, g.clearUserCookie = b, g.setVars = d, g.event = function (b, d, k) {
        h("trackEvent", {
          name: b,
          properties: d
        }, k);
      }, g.anonymize = function () {
        r(!1);
      }, g.shutdown = function () {
        h("shutdown");
      }, g.restart = function () {
        h("restart");
      }, g.log = function (b, d) {
        h("log", {
          level: b,
          msg: d
        });
      }, g.consent = function (b) {
        h("setIdentity", {
          consent: !arguments.length || b
        });
      };
    }(), s = "fetch", f = "XMLHttpRequest", g._w = {}, g._w[f] = m[f], g._w[s] = m[s], m[s] && (m[s] = function () {
      return g._w[s].apply(this, arguments);
    }), g._v = "2.0.0");
  }(wnd, wnd.document, wnd._fs_namespace, "script", wnd._fs_script);
};
var executeSnippetV1 = function executeSnippetV1() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref2$wnd = _ref2.wnd,
    wnd = _ref2$wnd === void 0 ? window : _ref2$wnd;
  (function (m, n, e, t, l, o, g, y) {
    if (e in m) {
      if (m.console && m.console.log) {
        m.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].');
      }
      return;
    }
    g = m[e] = function (a, b, s) {
      g.q ? g.q.push([a, b, s]) : g._api(a, b, s);
    };
    g.q = [];
    o = n.createElement(t);
    o.async = 1;
    o.crossOrigin = 'anonymous';
    o.src = 'https://' + _fs_script;
    y = n.getElementsByTagName(t)[0];
    y.parentNode.insertBefore(o, y);
    g.identify = function (i, v, s) {
      g(l, {
        uid: i
      }, s);
      if (v) g(l, v, s);
    };
    g.setUserVars = function (v, s) {
      g(l, v, s);
    };
    g.event = function (i, v, s) {
      g('event', {
        n: i,
        p: v
      }, s);
    };
    g.anonymize = function () {
      g.identify(!!0);
    };
    g.shutdown = function () {
      g("rec", !1);
    };
    g.restart = function () {
      g("rec", !0);
    };
    g.log = function (a, b) {
      g("log", [a, b]);
    };
    g.consent = function (a) {
      g("consent", !arguments.length || a);
    };
    g.identifyAccount = function (i, v) {
      o = 'account';
      v = v || {};
      v.acctId = i;
      g(o, v);
    };
    g.clearUserCookie = function () {};
    g.setVars = function (n, p) {
      g('setVars', [n, p]);
    };
    g._w = {};
    y = 'XMLHttpRequest';
    g._w[y] = m[y];
    y = 'fetch';
    g._w[y] = m[y];
    if (m[y]) m[y] = function () {
      return g._w[y].apply(this, arguments);
    };
    g._v = "1.3.0";
  })(wnd, wnd.document, wnd['_fs_namespace'], 'script', 'user');
};
var getDocumentVar = function getDocumentVar(globalVar) {
  return globalVar === 'window' ? 'document' : "".concat(globalVar, ".document");
};
var toV1String = function toV1String() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref3$shouldInsertScr = _ref3.shouldInsertScript,
    shouldInsertScript = _ref3$shouldInsertScr === void 0 ? true : _ref3$shouldInsertScr,
    _ref3$globalVar = _ref3.globalVar,
    globalVar = _ref3$globalVar === void 0 ? 'window' : _ref3$globalVar,
    _ref3$apiVersion = _ref3.apiVersion,
    apiVersion = _ref3$apiVersion === void 0 ? '1.3.0' : _ref3$apiVersion;
  return "(function(m,n,e,t,l,o,g,y){\n    if (e in m) {if(m.console && m.console.log) { m.console.log('FullStory namespace conflict. Please set window[\"_fs_namespace\"].');} return;}\n    g=m[e]=function(a,b,s){g.q?g.q.push([a,b,s]):g._api(a,b,s);};g.q=[];".concat(shouldInsertScript ? "\n    o=n.createElement(t);o.async=1;o.crossOrigin='anonymous';o.src='https://'+_fs_script;\n    y=n.getElementsByTagName(t)[0];y.parentNode.insertBefore(o,y);" : '', "\n    g.identify=function(i,v,s){g(l,{uid:i},s);if(v)g(l,v,s)};g.setUserVars=function(v,s){g(l,v,s)};g.event=function(i,v,s){g('event',{n:i,p:v},s)};\n    g.anonymize=function(){g.identify(!!0)};\n    g.shutdown=function(){g(\"rec\",!1)};g.restart=function(){g(\"rec\",!0)};\n    g.log = function(a,b){g(\"log\",[a,b])};\n    g.consent=function(a){g(\"consent\",!arguments.length||a)};\n    g.identifyAccount=function(i,v){o='account';v=v||{};v.acctId=i;g(o,v)};\n    g.clearUserCookie=function(){};\n    g.setVars=function(n, p){g('setVars',[n,p]);};\n    g._w={};y='XMLHttpRequest';g._w[y]=m[y];y='fetch';g._w[y]=m[y];\n    if(m[y])m[y]=function(){return g._w[y].apply(this,arguments)};\n    g._v=\"").concat(apiVersion, "\";\n})(").concat(globalVar, ",").concat(getDocumentVar(globalVar), ",").concat(globalVar, "['_fs_namespace'],'script','user');");
};
var initFS = function initFS(_a) {
  var orgId = _a.orgId,
    _b = _a.namespace,
    namespace = _b === void 0 ? 'FS' : _b,
    _c = _a.host,
    host = _c === void 0 ? 'fullstory.com' : _c,
    _d = _a.script,
    script = _d === void 0 ? 'edge.fullstory.com/s/fs.js' : _d;
  if (!orgId) {
    throw new Error('FullStory orgId is a required parameter');
  }
  window['_fs_host'] = host;
  window['_fs_script'] = script;
  window['_fs_org'] = orgId;
  window['_fs_namespace'] = namespace;
  executeSnippet();
};
var initFSV1 = function initFSV1(_a) {
  var orgId = _a.orgId,
    _b = _a.namespace,
    namespace = _b === void 0 ? 'FS' : _b,
    _c = _a.host,
    host = _c === void 0 ? 'fullstory.com' : _c,
    _d = _a.script,
    script = _d === void 0 ? 'edge.fullstory.com/s/fs.js' : _d;
  if (!orgId) {
    throw new Error('FullStory orgId is a required parameter');
  }
  window['_fs_host'] = host;
  window['_fs_script'] = script;
  window['_fs_org'] = orgId;
  window['_fs_namespace'] = namespace;
  executeSnippetV1();
};
var SnippetSrc = SnippetSrcV2;
var SnippetSrcV1 = toV1String();
var generateSnippetText = function generateSnippetText(_a) {
  var orgId = _a.orgId,
    _b = _a.namespace,
    namespace = _b === void 0 ? 'FS' : _b,
    _c = _a.host,
    host = _c === void 0 ? 'fullstory.com' : _c,
    _d = _a.script,
    script = _d === void 0 ? 'edge.fullstory.com/s/fs.js' : _d;
  if (!orgId) {
    throw new Error('FullStory orgId is a required parameter');
  }
  return "window['_fs_host'] = '".concat(host, "';\nwindow['_fs_script'] = '").concat(script, "';\nwindow['_fs_org'] = '").concat(orgId, "';\nwindow['_fs_namespace'] = '").concat(namespace, "';\n").concat(SnippetSrc, "\n");
};
var generateSnippetTextV1 = function generateSnippetTextV1(_a) {
  var orgId = _a.orgId,
    _b = _a.namespace,
    namespace = _b === void 0 ? 'FS' : _b,
    _c = _a.host,
    host = _c === void 0 ? 'fullstory.com' : _c,
    _d = _a.script,
    script = _d === void 0 ? 'edge.fullstory.com/s/fs.js' : _d;
  if (!orgId) {
    throw new Error('FullStory orgId is a required parameter');
  }
  return "window['_fs_host'] = '".concat(host, "';\nwindow['_fs_script'] = '").concat(script, "';\nwindow['_fs_org'] = '").concat(orgId, "';\nwindow['_fs_namespace'] = '").concat(namespace, "';\n").concat(SnippetSrcV1, "\n");
};
export { SnippetSrc, SnippetSrcV1, generateSnippetText, generateSnippetTextV1, initFS, initFSV1 };